export default (theme) => ({
  [theme.breakpoints.down("sm")]: {
    boxShadow: "inset 0 0 0 300px rgba(212, 211, 225, 0.9)",
    backgroundPositionX: "75%!important",
  },

  breakWord: {
    whiteSpace: "unset",
    wordBreak: "break-word",
  },
  subNavTitle: {
    "& div > span": {
      fontWeight: "bold",
    },
  },
  mainNavTitle: {
    "& div > span": {
      textTransform: "uppercase",
      fontWeight: "bold",
    },
  },

  snackbar: {
    [theme.breakpoints.down("sm")]: {
      bottom: "56px",
    },
  },
  snackbarContent: {
    backgroundColor: "rgb(84, 39, 133, 0.90 )",
    paddingBottom: "16px",
    "& div:last-child": {
      paddingLeft: "0",
      marginLeft: "0",
    },
  },

  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
  },
  dialogContainer: {
    alignItems: "flex-start",
  },
  divFabButton: {
    margin: theme.spacing(1),
    position: "fixed",
    bottom: "4vh",
    right: "1vw",
    zIndex: "9999",
    "& button": {
      borderRadius: "2rem",
    },
  },
  fabButton: {
    margin: "8px 8px 8px 0",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      margin: "5px 0",
    },
  },
  fabTab: {
    padding: 0,
  },
  bottomNavigation: {
    backgroundColor: "#fdfdfd",
    borderTop: "1px solid #fdfdfd",
    boxShadow: "0px -10px 95px #ccc",
    zIndex: "1000",
    position: "fixed",
    bottom: "0",
    width: "100%",
    "& button": {
      maxWidth: "none",
      color: "#532786",
      [theme.breakpoints.only("xs")]: {
        minWidth: "auto",
      },
    },
    "& a": {
      maxWidth: "none",
      color: "#532786",
      [theme.breakpoints.only("xs")]: {
        minWidth: "auto",
      },
      "& :active": {
        color: "#b1006d",
      },
    },
  },

  footerIcon: {
    maxWidth: "120px",
    display: "block",
    // margin: "20px auto",
    paddingLeft: "30px",
  },
  snackbarContent: {
    backgroundColor: "rgb(84, 39, 133, 0.90 )",
  },
  snackbarbtn: {
    color: "#fff",
  },
  appBar: {
    backgroundColor: "#d5e14d",
    "& > div": {
      minHeight: "64px",
    },
  },
  bannerImg: {
    height: "58vh",
    backgroundSize: "cover!important",
    [theme.breakpoints.down("sm")]: {
      height: "400px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  bannerText: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      justifyContent: "center",
      marginTop: "15%",
    },
  },
  carouselAligner: {
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      justifyContent: "flex-end",
    },
  },
  centeredText: {
    textAlign: "center",
  },
  chevronArrow: {
    // borderWidth: "3px",
    borderColor: "#9f9f9f",
    fontSize: "3rem",
    color: "#9f9f9f",
    borderRadius: "100%",
    position: "relative",
    top: "-20px",
    [theme.breakpoints.only("md")]: {
      fontSize: "2.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      top: "50px",
      borderColor: "#565656",
      color: "#565656",
    },
  },
  customMaxWidth: {
    maxWidth: "none", // arbitrary value
  },
  transparentBorder: {
    borderColor: "transparent !important",
  },
  drawerPaper: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: "250px",
    },
  },
  fullList: {
    width: "auto",
  },
  flex: {
    flex: 1,
  },
  horizontalOrientation: {
    display: "flex",
    flexDirection: "row",
  },
  verticalOrientation: {
    display: "flex",
    flexDirection: "column",
  },
  bold: {
    fontWeight: "700",
  },
  italics: {
    fontStyle: "italic",
  },
  spacer: {
    marginTop: "15px",
    marginBottom: "15px",
  },
  indent2rem: {
    textIndent: "2rem",
  },

  indent3rem: {
    textIndent: "3rem",
  },

  nested: {
    paddingLeft: theme.spacing(4),
  },
  navRight: {
    position: "absolute",
    right: "0",
    top: "10px",
    display: "flex",
    alignItems: "center",
  },
  navLeft: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      left: "7%",
    },
  },
  logo: {
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  },
  list: {
    "& span": {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      "& > div:first-child": {
        height: "30px",
      },
      "& ul": {
        height: "100%",
        overflowY: "auto",
      },
    },
  },
  listPadding: {
    paddingTop: 0,
    listStyleType: "disc",
  },
  mainContent: {
    [theme.breakpoints.up("md")]: {
      paddingTop: "41px",
    },
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "55px",
      paddingTop: "40px",
    },
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    color: "#FFFFFF",
  },
  textField: {
    width: "100%",
  },
  whiteText: {
    color: "#fff",
  },
  violetBand: {
    backgroundColor: "#4d2679",
    padding: "25px",
  },
  formControl: {
    margin: theme.spacing(3),
  },
  group: {
    margin: theme.spacing(2),
  },
  finderBG: {
    background: "url(../images/eastwestbank-findacard-bg.jpg)",
    marginBottom: "35px",
    backgroundSize: "cover",
  },
  paperPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  cardPadding: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing(3),
  }),
  cardHorizontalPadding: theme.mixins.gutters({
    paddingTop: 16,
    marginTop: theme.spacing(3),
  }),
  productTitle: {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    fontSize: 20,
  },
  productItemTitle: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: 20,
  },
  productItemDescription: {
    fontSize: 18,
  },
  secondaryBackgroundColor: {
    backgroundColor: theme.palette.secondary.main,
  },
  primaryBackgroundColor: {
    backgroundColor: theme.palette.primary.main,
  },

  primaryColorText: {
    color: theme.palette.primary.main,
  },
  root: {
    flexGrow: 1,
  },
  secondaryColorText: {
    color: theme.palette.secondary.main,
  },
  ewbGreenBackground: {
    backgroundColor: "#c6d147",
  },
  noPaddingOnMobile: {
    paddingLeft: 80,
    paddingRight: 80,
    paddingTop: 0,
    "@media screen and (max-width: 950px)": {
      padding: 0,
    },
  },

  //for responsiveness
  cardPaddingConfig: {
    padding: "5.3vw",
    paddingTop: 30,
    "@media (max-width: 1100px)": {
      padding: 30,
    },
  },

  fontConfig: {
    fontSize: "2.14vw",
    padding: 10,
    "@media (max-width: 1100px)": {
      fontSize: 20,
      padding: 15,
    },
    "@media (min-width: 1501px)": {
      fontSize: 30,
      padding: 10,
    },
  },
  descriptionFontConfig: {
    fontSize: "1.1vw",
    "@media (max-width: 1100px)": {
      fontSize: 14,
    },
    "@media (min-width: 1501px)": {
      fontSize: 18,
    },
  },
  helperTextConfig: {
    fontSize: "1.29vw",
    "@media (max-width: 1100px)": {
      fontSize: 13,
    },
    "@media (min-width: 1501px)": {
      fontSize: 16,
    },
  },

  //rfc
  justifyRight: {
    flex: 1,
    justifyContent: "right",
    width: "100%",
    justifyItems: "right",
  },
  carouselStyling: {
    height: "370px",
    display: "flex!important",
    [theme.breakpoints.only("md")]: {
      width: "98%!important",
    },
    [theme.breakpoints.down("md")]: {
      position: "relative",
    },
    [theme.breakpoints.up("lg")]: {
      "& section": {
        paddingRight: "30px",
      },
    },
    "& > div:first-child": {
      backgroundColor: "#c6d147",
      [theme.breakpoints.down("md")]: {
        backgroundColor: "rgba(198, 209, 71, 0.7)",
        position: "absolute",
        height: "370px",
      },
    },
  },

  carouseldotAligner: {
    justifyContent: "flex-end",
  },

  singleSlideItemContainer: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    minHeight: "200px",
  },
  cover: {
    width: "100%",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      position: "absolute",
      top: 0,
      zIndex: -1,
    },
  },
  carouselText: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    "& hr": {
      borderColor: "black",
      borderWidth: "0.5px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    "& h3": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    [theme.breakpoints.up("lg")]: {
      width: "610px",
    },
    "@media (min-width: 1280px) and (max-width: 1400px)": {
      marginLeft: "50px",
    },
  },
  hoverableComponent: {
    "&:hover": {
      // backgroundColor: theme.palette.secondary.main,
      textDecoration: "none",
      cursor: "pointer",
    },
  },

  smallerFont: {
    //banner
    fontSize: "1.1rem",
  },
});
